<section class="banner-area mb-5">
    <div class="container">
        <div class="main-banner-content d-flex flex-column flex-lg-row align-content-between align-items-center">
            <div class="boxL text-center text-lg-start mb-5 mb-lg-0">

                <h1>{{'text_slideh1'|translate}}</h1>
                <p>{{'text_home_message1'|translate}}</p>
                <a href="https://panel.entegi.com/account/register?ref=798BI" target="_blank" rel="noopener noreferrer"
                    class="default-btn">{{'text_get_start_free'|translate}}</a>
            </div>
            <div class="ms-lg-auto pt-lg-5">
                <div class="figureBox">
                    <img src="../../../../../assets/img/shopify_screen.webp" alt="shopify" width="450" height="620" class="img-fluid">
                </div>
            </div>

        </div>

    </div>
</section>